import React from "react";
import styles from "./details.module.css";
import { Col, Row } from "react-bootstrap";
import { GrCurrency } from "react-icons/gr";
import Header from "../../Component/Header/Header";
import { Link, useNavigate } from "react-router-dom";
import { CiUser, CiLocationOn, CiClock2 } from "react-icons/ci";
import { Helmet } from "react-helmet";

const Detail = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <div className="right-aside">
        <Helmet>Project Details</Helmet>
        <Row>
          <Col md={8} sm={12}>
            <Header />

            {/*------------ header-section------------ */}

            <div className={styles.main_section}>
              <div className={styles.headerSection}>
                <h6>Project Detail</h6>
                <img src="/images/pencil.png" alt="icon" />
              </div>

              <div className={styles.details_section}>
                <div className="d-flex justify-content-between mb-3">
                  <img src="/images/zomato.png" alt="zomato" />
                  <button>
                    {" "}
                    <CiUser size={16} /> 12 Applies
                  </button>
                </div>
                <div>
                  <h5>Users of Zomato who Uses on daily basis</h5>
                  <h6>Type : Group Study</h6>
                  <div className="d-flex gap-2">
                    <p>
                      <CiUser size={16} /> Age - 35 to 40
                    </p>
                    <p>
                      <CiClock2 size={16} /> 60 Min
                    </p>
                    <p>
                      <CiLocationOn size={16} /> Remote
                    </p>
                    <p>
                      <GrCurrency size={16} /> ₹2500
                    </p>
                  </div>
                </div>

                <div className={styles.desp_section}>
                  <h5>Description</h5>
                  <p>
                    Horem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                    <ul>
                      <li> Class patent</li>
                      <li> Class patent</li>
                      <li> Class patent</li>
                      <li> Class patent</li>
                    </ul>
                    Horem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nunc vulputate libero et velit interdum, ac aliquet odio
                    mattis. Class aptent taciti sociosqu ad litora torquent per
                    conubia nostra, per inceptos himenaeos.
                  </p>
                </div>
              </div>

              <div className={styles.short_candidate}>
                <div className="d-flex gap-2">
                  <h6>Shortlist Candidates</h6>
                  <Link to={""}>View All</Link>
                </div>
                <div
                  className={styles.box}
                  onClick={() => navigate(`/projectdetail`)}
                >
                  <div className="d-flex gap-3">
                    <img src="/images/candidate.jpg" alt="candidate" />
                    <div className="d-flex flex-column">
                      <p>Nishant Choudhary</p>
                      <span>Age 24</span>
                      <span>Hotstar User</span>
                    </div>
                  </div>
                  <span>Applied 12 hr ago</span>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} className="p-0">
            <div className={styles.right_section}>
              <div className={styles.notify_section}>
                <h5>Notification</h5>
                <div className={styles.notify_child}>
                  <img src="/images/IconSet.jpg" alt="bug" />
                  <div>
                    <p>You have a bug that needs to be fixed.</p>
                    <span>Just Now</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/userSet.png" alt="user" />
                  <div>
                    <p>New user registered</p>
                    <span>59 minutes ago</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/IconSet.jpg" alt="bug" />
                  <div>
                    <p>You have a bug that needs to be fixed.</p>
                    <span>12 hours ago</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img
                    src="/images/Broadcast.jpg"
                    alt="Broadcast"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <div className="ps-1">
                    <p>Andi Lane subscribed to you</p>
                    <span>Today, 11:59 AM</span>
                  </div>
                </div>
              </div>

              <div className={styles.notify_section}>
                <h5>Activites</h5>
                <div className={styles.notify_child}>
                  <img src="/images/user_1.png" alt="user" />
                  <div>
                    <p>You have a bug that needs to be fixed.</p>
                    <span>Just Now</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/user_w.png" alt="user" />
                  <div>
                    <p>Modified A data in Page X</p>
                    <span>59 minutes ago</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/male.png" alt="user" />
                  <div>
                    <p>YModified A data in Page X</p>
                    <span>12 hours ago</span>
                  </div>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/logo.png" alt="user" />
                  <div className="ps-1">
                    <p>Deleted a page in Project X</p>
                    <span>Today, 11:59 AM</span>
                  </div>
                </div>
              </div>

              {/* ---------Contact-section---------- */}

              <div className={styles.notify_section}>
                <h5>Contact</h5>
                <div className={styles.notify_child}>
                  <img src="/images/user_1.png" alt="user" />
                  <p>Nishant Choudhary</p>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/user_w.png" alt="user" />
                  <p>Natali Craig</p>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/male.png" alt="user" />
                  <p>Abhishek Singh</p>
                </div>
                <div className={styles.notify_child}>
                  <img src="/images/logo.png" alt="user" />
                  <p>Punit Bharti</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Detail;
